import {
  AtomButton,
  IconButton,
  PencilIcon,
  RearrangeOutlineIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import { useInsightsContext } from "./InsightsContext"
import styles from "./InsightsEditButtons.module.scss"
import { usePolyglot } from "src/contexts"
import { InsightsState } from "src/types"

const polyglotPrefix = "pages.home.insights."

export function InsightsEditButtons() {
  const {
    insightsState,
    setInsightsState,
  } = useInsightsContext()

  const polyglot = usePolyglot()

  const startEditing = useCallback(
    () => {
      setInsightsState(InsightsState.Editing)
    },
    [setInsightsState],
  )

  const startReordering = useCallback(
    () => {
      setInsightsState(InsightsState.Reordering)
    },
    [setInsightsState],
  )

  const returnToDefault = useCallback(
    () => {
      setInsightsState(InsightsState.Default)
    },
    [setInsightsState],
  )

  if (insightsState !== InsightsState.Default) {
    return (
      <AtomButton
        onClick={returnToDefault}
        id="insights-done-button"
      >
        {polyglot.t(`${polyglotPrefix}header_done_cta`)}
      </AtomButton>
    )
  }

  return (
    <div className={styles.container}>
      <IconButton
        onClick={startReordering}
        stylePreset="withoutBackground"
        aria-label={polyglot.t(`${polyglotPrefix}rearrange_cta_aria_label`)}
        id="reorder-insights-button"
      >
        <RearrangeOutlineIcon/>
      </IconButton>
      <IconButton
        onClick={startEditing}
        stylePreset="withoutBackground"
        aria-label={polyglot.t(`${polyglotPrefix}edit_cta_aria_label`)}
        id="edit-insights-button"
      >
        <PencilIcon/>
      </IconButton>
    </div>
  )
}
